import React, { useState } from "react";
import classNames from "classnames";
import {
  listVoyages,
  createExpedition,
  initiatePayment,
  getExpeditionShow,
} from "../../../services/crm/clementino-service";
import {
  CreateExpeditionDTO,
  ClementinoExpedition,
  normalizeStatus,
} from "../../../models/crm/clementino/clementino-types";
import { money, toFloat } from "./envois-shared";
import {
  ArrowPathIcon,
  XMarkIcon,
  ChatBubbleLeftRightIcon,
  PlusIcon,
  DocumentTextIcon,
  MagnifyingGlassIcon,
  FunnelIcon,
  EyeIcon,
  EyeSlashIcon,
  CheckCircleIcon,
  DocumentArrowDownIcon,
  ShareIcon,
} from "@heroicons/react/24/outline";

export const CAMPAIGNS_LIST = [
  { id: "c1", name: "Campagne Bruxelles · S40", from: "DOUALA", fromC: "CM", to: "BRUXELLES", toC: "BE", corridor: "Cameroun → Belgique", mode: "Aérien", date: "2026-09-28", dateLabel: "dimanche 28 sept. 2026", heure: "10:40", cutoff: "27/09 17:00", eta: "30/09", vehicle: "Vol SN 372", cap: 500, rem: 45, tarif: 10500 },
  { id: "c2", name: "Express Houston · S40", from: "DOUALA", fromC: "CM", to: "HOUSTON", toC: "US", corridor: "Cameroun → États-Unis", mode: "Express", date: "2026-09-29", dateLabel: "lundi 29 sept. 2026", heure: "13:20", cutoff: "29/09 08:00", eta: "02/10", vehicle: "Vol ET 908", cap: 300, rem: 60, tarif: 22000 },
  { id: "c3", name: "Campagne Abidjan · S40", from: "DOUALA", fromC: "CM", to: "ABIDJAN", toC: "CI", corridor: "Cameroun → Côte d'Ivoire", mode: "Aérien", date: "2026-09-29", dateLabel: "lundi 29 sept. 2026", heure: "15:05", cutoff: "28/09 18:00", eta: "30/09", vehicle: "Vol HF 705", cap: 600, rem: 380, tarif: 6000 },
  { id: "c4", name: "Campagne Paris · S40", from: "DOUALA", fromC: "CM", to: "PARIS", toC: "FR", corridor: "Cameroun → France", mode: "Aérien", date: "2026-09-30", dateLabel: "mardi 30 sept. 2026", heure: "23:15", cutoff: "29/09 18:00", eta: "03/10", vehicle: "Vol AF 947", cap: 800, rem: 320, tarif: 9500 },
  { id: "c5", name: "Campagne Francfort · S40", from: "DOUALA", fromC: "CM", to: "FRANCFORT", toC: "DE", corridor: "Cameroun → Allemagne", mode: "Aérien", date: "2026-10-01", dateLabel: "jeudi 1 oct. 2026", heure: "22:30", cutoff: "30/09 17:00", eta: "04/10", vehicle: "Vol LH 561", cap: 400, rem: 0, tarif: 10000 },
  { id: "c6", name: "Route Brazzaville · S40", from: "DOUALA", fromC: "CM", to: "BRAZZAVILLE", toC: "CG", corridor: "Cameroun → Congo", mode: "Route", date: "2026-10-01", dateLabel: "mercredi 1 oct. 2026", heure: "05:00", cutoff: "30/09 16:00", eta: "06/10", vehicle: "Camion LT 874 OC", stops: "Yaoundé, Sangmélima, Ouesso", cap: 8000, rem: 5200, tarif: 1800 },
  { id: "c7", name: "Campagne Amsterdam · S40", from: "DOUALA", fromC: "CM", to: "AMSTERDAM", toC: "NL", corridor: "Cameroun → Pays-Bas", mode: "Aérien", date: "2026-10-02", dateLabel: "vendredi 2 oct. 2026", heure: "21:50", cutoff: "01/10 17:00", eta: "05/10", vehicle: "Vol KL 588", cap: 450, rem: 210, tarif: 10000 },
  { id: "c8", name: "Groupage Montréal #CA-12", from: "DOUALA", fromC: "CM", to: "MONTRÉAL", toC: "CA", corridor: "Cameroun → Canada", mode: "Maritime", date: "2026-10-04", dateLabel: "samedi 4 oct. 2026", heure: "08:00", cutoff: "03/10 12:00", eta: "12/11", vehicle: "Conteneur 40' #CA-12", cap: 12000, rem: 3400, tarif: 4000 },
  { id: "c9", name: "Groupage Le Havre #FR-08", from: "DOUALA", fromC: "CM", to: "LE HAVRE", toC: "FR", corridor: "Cameroun → France", mode: "Maritime", date: "2026-10-09", dateLabel: "vendredi 9 oct. 2026", heure: "10:00", cutoff: "08/10 12:00", eta: "05/11", vehicle: "Conteneur 20' #FR-08", cap: 10000, rem: 7100, tarif: 3500 }
];

export const CORRIDORS_LIST = [
  "Tous les corridors",
  "Cameroun → France",
  "Cameroun → Belgique",
  "Cameroun → Allemagne",
  "Cameroun → Pays-Bas",
  "Cameroun → Canada",
  "Cameroun → États-Unis",
  "Cameroun → Côte d'Ivoire",
  "Cameroun → Congo",
  "France → Cameroun",
  "Livraison urbaine Douala",
  "Livraison urbaine Yaoundé"
];

interface FloatingActionsRailProps {
  onOpenIntlWizard: () => void;
  onOpenUrbainModal: () => void;
  onOpenProspectModal: () => void;
  onOpenManifest: () => void;
  onOpenSuiviColisModal: () => void;
  onToggleFilters?: () => void;
  onFlash: (msg: string) => void;
}

export function FloatingActionsRail({
  onOpenIntlWizard,
  onOpenUrbainModal,
  onOpenProspectModal,
  onOpenManifest,
  onOpenSuiviColisModal,
  onToggleFilters,
  onFlash,
}: FloatingActionsRailProps) {
  const [railVisible, setRailVisible] = useState(true);

  return (
    <>
      <div className="fixed right-3.5 top-1/2 -translate-y-1/2 z-40 flex flex-col items-end gap-2.5">
        <button
          type="button"
          onClick={() => setRailVisible(!railVisible)}
          title={railVisible ? "Masquer les boutons rapides" : "Afficher les boutons rapides"}
          className="h-8 px-2.5 bg-[#1f1b2e] hover:bg-purple-950 text-white rounded-full shadow-lg border border-purple-400/40 text-[11px] font-bold flex items-center gap-1.5 transition-all cursor-pointer backdrop-blur-xs opacity-90 hover:opacity-100"
        >
          {railVisible ? (
            <>
              <EyeSlashIcon className="w-3.5 h-3.5 text-purple-300" />
              <span>Masquer</span>
            </>
          ) : (
            <>
              <EyeIcon className="w-3.5 h-3.5 text-purple-300" />
              <span>Boutons rapides</span>
            </>
          )}
        </button>

        {railVisible && (
          <div className="flex flex-col gap-2 p-1.5 bg-white/95 backdrop-blur-md border border-[#ece7f8] rounded-2xl shadow-xl animate-fade-in">
            <button
              type="button"
              onClick={() => onFlash("Messagerie équipe ouverte")}
              title="Messagerie équipe"
              className="w-18 h-14 p-1.5 rounded-xl bg-rose-50 hover:bg-rose-100 text-rose-700 flex flex-col items-center justify-center gap-1 text-[11px] font-bold shadow-2xs transition-colors cursor-pointer"
            >
              <ChatBubbleLeftRightIcon className="w-4 h-4" />
              <span>Chat</span>
            </button>

            <button
              type="button"
              onClick={onOpenIntlWizard}
              title="Créer une expédition internationale (stepper fidèle)"
              className="w-18 h-14 p-1.5 rounded-xl bg-gradient-to-br from-orange-500 to-amber-600 hover:from-orange-600 hover:to-amber-700 text-white flex flex-col items-center justify-center gap-1 text-[11px] font-bold shadow-xs transition-transform hover:scale-102 cursor-pointer"
            >
              <PlusIcon className="w-4 h-4 stroke-2" />
              <span className="leading-tight text-center">Expéd. intl.</span>
            </button>

            <button
              type="button"
              onClick={onOpenUrbainModal}
              title="Créer une livraison urbaine (stepper Douala/Yaoundé)"
              className="w-18 h-14 p-1.5 rounded-xl bg-blue-600 hover:bg-blue-700 text-white flex flex-col items-center justify-center gap-1 text-[11px] font-bold shadow-xs transition-transform hover:scale-102 cursor-pointer"
            >
              <PlusIcon className="w-4 h-4 stroke-2" />
              <span className="leading-tight text-center">Urbain</span>
            </button>

            <button
              type="button"
              onClick={onOpenProspectModal}
              title="Enregistrer un prospect / devis commercial"
              className="w-18 h-14 p-1.5 rounded-xl bg-purple-700 hover:bg-purple-800 text-white flex flex-col items-center justify-center gap-1 text-[11px] font-bold shadow-xs transition-transform hover:scale-102 cursor-pointer"
            >
              <PlusIcon className="w-4 h-4 stroke-2" />
              <span className="leading-tight text-center">Prospect</span>
            </button>

            <button
              type="button"
              onClick={onOpenManifest}
              title="Générer ou imprimer le manifeste de départ"
              className="w-18 h-14 p-1.5 rounded-xl bg-[#6d28d9] hover:bg-purple-900 text-white flex flex-col items-center justify-center gap-1 text-[11px] font-bold shadow-xs transition-colors cursor-pointer"
            >
              <DocumentTextIcon className="w-4 h-4" />
              <span>Manifeste</span>
            </button>

            <button
              type="button"
              onClick={onOpenSuiviColisModal}
              title="Rechercher et tracer un colis dans une boîte modale"
              className="w-18 h-14 p-1.5 rounded-xl bg-slate-600 hover:bg-slate-700 text-white flex flex-col items-center justify-center gap-1 text-[11px] font-bold shadow-xs transition-colors cursor-pointer"
            >
              <MagnifyingGlassIcon className="w-4 h-4" />
              <span>Suivi colis</span>
            </button>

            {onToggleFilters && (
              <button
                type="button"
                onClick={onToggleFilters}
                title="Afficher ou masquer les filtres"
                className="w-18 h-14 p-1.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white flex flex-col items-center justify-center gap-1 text-[11px] font-bold shadow-xs transition-colors cursor-pointer"
              >
                <FunnelIcon className="w-4 h-4" />
                <span>Filtre</span>
              </button>
            )}
          </div>
        )}
      </div>

      <button
        type="button"
        onClick={() => onFlash("WhatsApp Business ouvert")}
        title="Ouvrir WhatsApp Business"
        className="fixed left-5 bottom-5 z-40 w-13 h-13 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white font-extrabold text-sm flex items-center justify-center shadow-2xl transition-transform hover:scale-108 cursor-pointer ring-4 ring-emerald-200/50"
      >
        WA
      </button>
    </>
  );
}

// -------------------------------------------------------------
// EXACT REPLICA OF THE USER'S HTML MODAL & SCREENSHOT (STEPPER)
// -------------------------------------------------------------
interface IntlWizardModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (newCode: string) => void;
  onFlash: (msg: string) => void;
}

export function IntlWizardModal({
  isOpen,
  onClose,
  onSuccess,
  onFlash,
}: IntlWizardModalProps) {
  const [step, setStep] = useState(1);
  const [selectedCampId, setSelectedCampId] = useState<string | null>(null);
  const [campaigns, setCampaigns] = useState<any[]>([]);
  const [loadingCamps, setLoadingCamps] = useState(false);
  const [campsError, setCampsError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  React.useEffect(() => {
    if (isOpen) {
      setLoadingCamps(true);
      setCampsError(null);
      listVoyages()
        .then((voyages) => {
          if (Array.isArray(voyages) && voyages.length > 0) {
            const adapted = voyages.map((v) => {
              const e1 = v.etape?.[0] || v.etapes?.[0];
              return {
                id: String(v.id),
                name: `Campagne Fret · #${v.id}`,
                from: "DOUALA",
                fromC: "CM",
                to: "DESTINATION",
                toC: "FR",
                corridor: "Cameroun → International",
                mode: (e1?.moyen_transport === "VOL" ? "Aérien" : e1?.moyen_transport === "TRAIN" ? "Train" : "Route") as string,
                date: v.date_depart ? v.date_depart.slice(0, 10) : "",
                dateLabel: v.date_depart || "Date à confirmer",
                heure: v.heure_depart || "10:00",
                cutoff: "Veille 18:00",
                eta: "À confirmer",
                vehicle: e1?.numero_vol || e1?.vehicule || "Fret programmé",
                cap: 500,
                rem: 500,
                tarif: 10000,
                raw: v,
              };
            });
            setCampaigns(adapted);
          } else {
            setCampaigns([]);
          }
        })
        .catch(() => {
          setCampsError("Impossible de charger les voyages depuis Clementino.");
          setCampaigns([]);
        })
        .finally(() => setLoadingCamps(false));
    }
  }, [isOpen]);

  // Filter bar inside Step 1
  const [searchCamp, setSearchCamp] = useState("");
  const [filterMode, setFilterMode] = useState("Tous");
  const [filterCorridor, setFilterCorridor] = useState("Tous les corridors");
  const [filterDateFrom, setFilterDateFrom] = useState("");
  const [filterDateTo, setFilterDateTo] = useState("");

  // Step 2 Fields
  const [sName, setSName] = useState("ETONDE Grace");
  const [sCC, setSCC] = useState("CM +237");
  const [sPhone, setSPhone] = useState("699 920 648");
  const [sIdType, setSIdType] = useState("CNI");
  const [sIdNum, setSIdNum] = useState("");
  const [pickup, setPickup] = useState(false);

  const [rName, setRName] = useState("Tanga Aurélie");
  const [rCC, setRCC] = useState("FR +33");
  const [rPhone, setRPhone] = useState("6 12 45 78 90");
  const [rCity, setRCity] = useState("Paris");
  const [rAddr, setRAddr] = useState("12 Rue de la Paix, 75002 Paris");
  const [deliveryType, setDeliveryType] = useState<"domicile" | "relais">("relais");
  const [selectedRelaisIdx, setSelectedRelaisIdx] = useState(0);

  const [nbColis, setNbColis] = useState("2");
  const [poids, setPoids] = useState("18.5");
  const [dims, setDims] = useState("40 × 30 × 30");
  const [nature, setNature] = useState("Alimentaire sec");
  const [valeur, setValeur] = useState("150000");
  const [lead, setLead] = useState("Facebook Ads");
  const [desc, setDesc] = useState("Riz, patate, igname");
  const [insurance, setInsurance] = useState(true);
  const [packing, setPacking] = useState(false);
  const [notify, setNotify] = useState(true);

  // Step 3 Fields
  const [payMode, setPayMode] = useState<"direct" | "ref" | "later">("direct");
  const [refOM, setRefOM] = useState("");
  const [refTouch, setRefTouch] = useState("");

  // Step 4
  const [generatedCode, setGeneratedCode] = useState("");

  if (!isOpen) return null;

  const currentCamp = CAMPAIGNS_LIST.find((c) => c.id === selectedCampId);
  const numPoids = toFloat(poids, 1);
  const numVal = toFloat(valeur, 0);
  const transport = currentCamp ? numPoids * toFloat(currentCamp.tarif, 0) : 0;
  const gestion = 1000;
  const liv = (pickup ? 3000 : 0) + (deliveryType === "domicile" ? 5000 : 0);
  const assur = insurance ? numVal * 0.005 : 0;
  const entrepot = 1500;
  const douane = currentCamp ? (currentCamp.mode === "Maritime" ? 25000 : currentCamp.mode === "Route" ? 15000 : 10000) : 0;
  const emb = packing ? 2500 : 0;
  const notif = 0;
  const total = transport + gestion + liv + assur + entrepot + douane + emb + notif;

  const activeCamps = campaigns.length > 0 ? campaigns : CAMPAIGNS_LIST;
  const filteredCamps = activeCamps.filter((c) => {
    if (filterMode !== "Tous" && c.mode !== filterMode) return false;
    if (filterCorridor !== "Tous les corridors" && c.corridor !== filterCorridor) return false;
    if (filterDateFrom && c.date < filterDateFrom) return false;
    if (filterDateTo && c.date > filterDateTo) return false;
    if (searchCamp.trim()) {
      const q = searchCamp.toLowerCase();
      if (![c.name, c.from, c.to, c.vehicle, c.corridor].join(" ").toLowerCase().includes(q)) {
        return false;
      }
    }
    return true;
  });

  const handleNext = () => {
    if (step === 1) {
      if (!selectedCampId) {
        onFlash("Veuillez sélectionner une campagne de départ.");
        return;
      }
      setStep(2);
    } else if (step === 2) {
      if (!sName.trim() || !rName.trim()) {
        onFlash("Veuillez renseigner l'expéditeur et le destinataire.");
        return;
      }
      setStep(3);
    } else if (step === 3) {
      setSubmitting(true);
      (async () => {
        try {
          const payload: CreateExpeditionDTO = {
            contactExpediteur: sName,
            telExpediteur: `${sCC} ${sPhone}`.trim(),
            adresseExpediteur: pickup ? "Ramassage à domicile demandé" : undefined,
            contactDestinataire: rName,
            telDestinataire: `${rCC} ${rPhone}`.trim(),
            adresseDestination: deliveryType === "domicile" ? rAddr : (RELAIS_OPTIONS[selectedRelaisIdx]?.addr || rAddr),
            villeExpedition: 1,
            villeDestination: 2,
            montant: total,
            payeur: "EXPEDITEUR",
            modePaiement: payMode === "direct" ? "ORANGE_MONEY" : payMode === "ref" ? (refOM ? "ORANGE_MONEY" : "INTOUCH") : "DEVIS",
            numeroTelPaiement: sPhone,
            colis: [
              {
                description: desc || "Effets personnels",
                poidsColis: numPoids,
                nombre: parseInt(nbColis) || 1,
                valeurMarchande: numVal,
              },
            ],
          };

          const res = await createExpedition(payload);
          const newCode = res.numLt || `EXP-${res.id}`;

          if (payMode === "direct") {
            try {
              await initiatePayment({
                numLts: [newCode],
                channel: "ORANGE_MONEY",
                phoneNumber: sPhone,
              });
              onFlash("Session de paiement Mobile Money initiée avec succès");
            } catch (pErr: any) {
              onFlash("Expédition créée mais erreur lors de l initiation du paiement: " + (pErr?.message || ""));
            }
          }

          setGeneratedCode(newCode);
          setStep(4);
          onSuccess(newCode);
        } catch (err: any) {
          onFlash("Erreur lors de la création de l expédition: " + (err?.message || "Erreur serveur"));
        } finally {
          setSubmitting(false);
        }
      })();
    } else {
      onClose();
    }
  };

  const handleBack = () => {
    if (step === 1) onClose();
    else if (step === 4) {
      setStep(1);
      setSelectedCampId(null);
    } else {
      setStep(step - 1);
    }
  };

  const resetFilters = () => {
    setSearchCamp("");
    setFilterMode("Tous");
    setFilterCorridor("Tous les corridors");
    setFilterDateFrom("");
    setFilterDateTo("");
  };

  const RELAIS_OPTIONS = [
    { name: `Relais ${currentCamp?.to || "Paris"} Centre`, addr: `Point relais partenaire · ${currentCamp?.to || "Paris"}`, badge: "le plus rapide", badgeBg: "#fef3c7", badgeFg: "#92400e" },
    { name: `Relais ${currentCamp?.to || "Paris"} Nord`, addr: `Point relais partenaire · ${currentCamp?.to || "Paris"}`, badge: "le plus économe", badgeBg: "#dcfce7", badgeFg: "#15803d" },
    { name: `Agence partenaire ${currentCamp?.to || "Paris"}`, addr: `Retrait au guichet · ${currentCamp?.to || "Paris"}`, badge: "recommandé", badgeBg: "#e0e7ff", badgeFg: "#3730a3" },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-3 md:p-6 bg-black/55 backdrop-blur-xs animate-fade-in font-['Public_Sans',sans-serif]">
      <div className="bg-[#f8f7fc] rounded-2xl border border-gray-200 shadow-2xl max-w-4xl w-full max-h-[92vh] flex flex-col overflow-hidden text-[#1f1b2e]">
        {/* Modal Top Header (Matches Screenshot) */}
        <div className="p-4 md:p-5 bg-white border-b border-gray-100 flex items-center justify-between shrink-0">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="w-2.5 h-2.5 rounded-xs bg-[#f97316]" />
              <h2 className="text-lg font-bold text-[#1f1b2e]">
                Nouvelle expédition internationale
              </h2>
            </div>
            {/* Step badges bar */}
            <div className="flex items-center gap-6 mt-3 text-xs">
              <div className={classNames("flex items-center gap-2", step === 1 ? "text-[#1f1b2e] font-bold" : step > 1 ? "text-emerald-700 font-semibold" : "text-gray-400 font-medium")}>
                <span className={classNames("w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold text-white", step === 1 ? "bg-[#6d28d9]" : step > 1 ? "bg-emerald-600" : "bg-gray-300 text-gray-700")}>
                  {step > 1 ? "1" : "1"}
                </span>
                <span>Campagne de départ</span>
                <span className="text-gray-300 font-normal ml-3">—</span>
              </div>
              <div className={classNames("flex items-center gap-2", step === 2 ? "text-[#1f1b2e] font-bold" : step > 2 ? "text-emerald-700 font-semibold" : "text-gray-400 font-medium")}>
                <span className={classNames("w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold text-white", step === 2 ? "bg-[#6d28d9]" : step > 2 ? "bg-emerald-600" : "bg-gray-300 text-gray-700")}>
                  {step > 2 ? "2" : "2"}
                </span>
                <span>Saisie de l&apos;expédition</span>
                <span className="text-gray-300 font-normal ml-3">—</span>
              </div>
              <div className={classNames("flex items-center gap-2", step >= 3 ? "text-[#1f1b2e] font-bold" : "text-gray-400 font-medium")}>
                <span className={classNames("w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold text-white", step >= 3 ? "bg-[#6d28d9]" : "bg-gray-300 text-gray-700")}>
                  3
                </span>
                <span>Récapitulatif & paiement</span>
              </div>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-1.5 rounded-lg text-gray-400 hover:text-gray-700 hover:bg-gray-100 cursor-pointer"
          >
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>

        {/* Modal Scrollable Body */}
        <div className="flex-1 overflow-y-auto p-4 md:p-6 tracking-scrollbar space-y-4 text-xs">
          {/* STEP 1: CAMPAIGNS LIST WITH EXACT PROGRESS JAUGE FROM USER HTML */}
          {step === 1 && (
            <div className="space-y-4">
              <div className="text-center">
                <h3 className="text-lg font-bold text-[#241f36]">
                  Liste des campagnes de départ
                </h3>
                <p className="text-xs text-gray-500 mt-0.5">
                  Choisis le vol, le conteneur ou le camion sur lequel le colis partira.
                </p>
              </div>

              {/* Big search bar */}
              <input
                type="text"
                value={searchCamp}
                onChange={(e) => setSearchCamp(e.target.value)}
                placeholder="Rechercher une campagne, une ville, un n° de vol ou de conteneur..."
                className="w-full h-10 px-3.5 bg-[#e9e6f2] border-0 rounded-xl text-xs text-[#1f1b2e] focus:outline-none focus:ring-2 focus:ring-purple-400"
              />

              {/* Filter controls matching screenshot */}
              <div className="flex items-center gap-2.5 flex-wrap">
                <div className="flex p-0.5 bg-[#ede9fe] rounded-lg gap-1">
                  {["Tous", "Aérien", "Express", "Maritime", "Route"].map((m) => (
                    <button
                      key={m}
                      type="button"
                      onClick={() => setFilterMode(m)}
                      className={classNames(
                        "px-3 py-1.5 rounded-md text-xs font-semibold cursor-pointer transition-all",
                        filterMode === m ? "bg-white text-[#4c1d95] shadow-xs" : "text-[#7c729b] hover:text-[#4c1d95]"
                      )}
                    >
                      {m}
                    </button>
                  ))}
                </div>

                <select
                  value={filterCorridor}
                  onChange={(e) => setFilterCorridor(e.target.value)}
                  className="h-9 px-2.5 bg-white border border-[#e2e8f0] rounded-lg text-xs text-[#1f1b2e]"
                >
                  {CORRIDORS_LIST.map((co) => (
                    <option key={co} value={co}>
                      {co}
                    </option>
                  ))}
                </select>

                <input
                  type="date"
                  value={filterDateFrom}
                  onChange={(e) => setFilterDateFrom(e.target.value)}
                  className="h-9 px-2.5 bg-white border border-[#e2e8f0] rounded-lg text-xs text-[#1f1b2e]"
                />
                <input
                  type="date"
                  value={filterDateTo}
                  onChange={(e) => setFilterDateTo(e.target.value)}
                  className="h-9 px-2.5 bg-white border border-[#e2e8f0] rounded-lg text-xs text-[#1f1b2e]"
                />

                <button
                  type="button"
                  onClick={resetFilters}
                  className="h-9 px-3 bg-[#fee2e2] hover:bg-rose-200 text-[#dc2626] font-semibold rounded-lg text-xs cursor-pointer"
                >
                  Réinitialiser
                </button>
                <button
                  type="button"
                  onClick={() => onFlash("Liste des campagnes imprimée")}
                  className="h-9 px-3 bg-[#dcfce7] hover:bg-emerald-200 text-[#15803d] font-semibold rounded-lg text-xs cursor-pointer"
                >
                  Imprimer
                </button>
              </div>

              {/* Campaign Cards matching screenshot & HTML */}
              <div className="grid gap-2.5 pt-1">
                {loadingCamps && (
                  <div className="p-3 text-xs text-purple-700 bg-purple-50 rounded-lg flex items-center gap-2">
                    <ArrowPathIcon className="w-4 h-4 animate-spin" />
                    <span>Chargement des campagnes de départ Clementino en cours...</span>
                  </div>
                )}
                {campsError && (
                  <div className="p-3 text-xs text-rose-700 bg-rose-50 border border-rose-200 rounded-lg">
                    {campsError}
                  </div>
                )}
                {filteredCamps.map((c) => {
                  const isSel = selectedCampId === c.id;
                  const isFull = c.rem <= 0;
                  const pct = Math.round((1 - c.rem / c.cap) * 100);
                  const barColor = pct > 85 ? "#ef4444" : pct > 60 ? "#f59e0b" : "#22c55e";

                  return (
                    <div
                      key={c.id}
                      onClick={() => !isFull && setSelectedCampId(c.id)}
                      className={classNames(
                        "p-3.5 bg-white rounded-xl border transition-all flex items-center justify-between gap-3 flex-wrap md:flex-nowrap cursor-pointer",
                        isSel
                          ? "border-[#6d28d9] ring-2 ring-purple-300/40 bg-purple-50/40"
                          : "border-[#ece7f8] hover:border-purple-200 hover:bg-purple-50/20"
                      )}
                    >
                      {/* Left Route & Mode */}
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 whitespace-nowrap">
                          <span className="px-2.5 py-1 bg-[#fed7aa] text-[#7c2d12] rounded-md font-bold text-[11px]">
                            {c.fromC} · {c.from}
                          </span>
                          <span className="text-gray-400">→</span>
                          <span className="px-2.5 py-1 bg-[#bbf7d0] text-[#14532d] rounded-md font-bold text-[11px]">
                            {c.toC} · {c.to}
                          </span>
                          <span className="px-2 py-0.5 rounded text-[10px] font-bold bg-[#e0f2fe] text-[#0369a1]">
                            {c.mode}
                          </span>
                        </div>
                        <div className="flex items-center gap-2 mt-2 min-w-0">
                          <span className="text-xs font-semibold text-gray-700 truncate">{c.name}</span>
                          <span className="shrink-0 whitespace-nowrap px-2 py-0.5 bg-gray-100 rounded-full font-mono text-[10px] text-gray-700">
                            {c.vehicle}
                          </span>
                        </div>
                      </div>

                      {/* Middle Depart & Vehicle */}
                      <div className="shrink-0 whitespace-nowrap">
                        <div className="text-xs text-gray-800">
                          Départ le <strong className="text-gray-900">{c.dateLabel}</strong> à {c.heure}
                        </div>
                        <div className="text-[11px] text-gray-500 mt-0.5">
                          Dépôt avant {c.cutoff} · ETA {c.eta}
                        </div>
                      </div>

                      {/* Right Remaining Gauge & Action Button */}
                      <div className="shrink-0 flex items-center gap-3">
                        <div className="w-28 whitespace-nowrap">
                          <div className={classNames("text-xs font-bold text-right", isFull ? "text-rose-600" : c.rem / c.cap < 0.2 ? "text-orange-600" : "text-emerald-700")}>
                            {isFull ? "Complet" : `${c.rem} kg restants`}
                          </div>
                          {/* THE EXACT PROGRESS JAUGE */}
                          <div className="h-1.5 bg-gray-200 rounded-full mt-1.5 overflow-hidden">
                            <div
                              className="h-full rounded-full transition-all"
                              style={{ width: `${pct}%`, backgroundColor: barColor }}
                            />
                          </div>
                          <div className="text-[10px] text-gray-400 text-right mt-1 font-medium">
                            {c.tarif.toLocaleString()} FCFA / kg
                          </div>
                        </div>

                        <button
                          type="button"
                          className={classNames(
                            "h-9 px-3.5 rounded-lg text-xs font-bold cursor-pointer border transition-colors",
                            isSel
                              ? "bg-[#6d28d9] text-white border-[#6d28d9]"
                              : isFull
                              ? "bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed"
                              : "bg-white hover:bg-purple-50 text-[#241f36] border-gray-300"
                          )}
                        >
                          {isSel ? "Sélectionné" : isFull ? "Complet" : "Sélectionner"}
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* STEP 2: FULL DETAILS (SENDER, RECEIVER, DELIVERY, COLIS) */}
          {step === 2 && (
            <div className="space-y-4">
              {/* Blue Banner with selected campaign */}
              <div className="p-3.5 bg-[#1e40af] rounded-xl text-white flex items-center justify-between gap-4 flex-wrap">
                <div>
                  <div className="text-[10px] uppercase font-bold text-blue-200 tracking-wider">Campagne sélectionnée</div>
                  <div className="text-sm font-bold mt-0.5">{currentCamp?.name}</div>
                  <div className="text-xs text-blue-100">{currentCamp?.from} → {currentCamp?.to} · {currentCamp?.vehicle} · {currentCamp?.dateLabel}</div>
                </div>
                <div className="text-right">
                  <div className="text-xs font-bold">{currentCamp?.tarif.toLocaleString()} FCFA / kg</div>
                  <div className="text-[11px] text-emerald-300 font-semibold">{currentCamp?.rem} kg restants</div>
                </div>
              </div>

              {/* Sender & Receiver Cards */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="p-4 bg-white border border-[#ece7f8] rounded-xl space-y-2.5">
                  <div className="text-xs font-bold uppercase tracking-wider text-[#c2410c]">Expéditeur</div>
                  <div>
                    <label className="block text-[11px] font-semibold text-gray-700 mb-0.5">Nom et prénoms</label>
                    <input
                      type="text"
                      value={sName}
                      onChange={(e) => setSName(e.target.value)}
                      className="w-full h-9 px-3 border border-indigo-200 rounded-lg text-xs"
                    />
                  </div>
                  <div>
                    <label className="block text-[11px] font-semibold text-gray-700 mb-0.5">Téléphone / WhatsApp</label>
                    <div className="flex gap-2">
                      <select value={sCC} onChange={(e) => setSCC(e.target.value)} className="w-24 h-9 px-2 border border-indigo-200 rounded-lg text-xs bg-white">
                        <option value="CM +237">CM +237</option>
                        <option value="FR +33">FR +33</option>
                        <option value="BE +32">BE +32</option>
                        <option value="US +1">US +1</option>
                      </select>
                      <input
                        type="text"
                        value={sPhone}
                        onChange={(e) => setSPhone(e.target.value)}
                        className="flex-1 h-9 px-3 border border-indigo-200 rounded-lg text-xs"
                      />
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <div className="w-1/3">
                      <label className="block text-[11px] font-semibold text-gray-700 mb-0.5">Pièce</label>
                      <select value={sIdType} onChange={(e) => setSIdType(e.target.value)} className="w-full h-9 px-2 border border-indigo-200 rounded-lg text-xs bg-white">
                        <option value="CNI">CNI</option>
                        <option value="Passeport">Passeport</option>
                        <option value="Titre de séjour">Titre de séjour</option>
                      </select>
                    </div>
                    <div className="flex-1">
                      <label className="block text-[11px] font-semibold text-gray-700 mb-0.5">N° pièce d&apos;identité</label>
                      <input
                        type="text"
                        value={sIdNum}
                        onChange={(e) => setSIdNum(e.target.value)}
                        placeholder="101165588"
                        className="w-full h-9 px-3 border border-indigo-200 rounded-lg text-xs"
                      />
                    </div>
                  </div>
                  <label className="flex items-center gap-2 cursor-pointer pt-1">
                    <input
                      type="checkbox"
                      checked={pickup}
                      onChange={(e) => setPickup(e.target.checked)}
                      className="w-4 h-4 accent-purple-700"
                    />
                    <span className="text-xs text-gray-700">Ramassage à domicile (+3 000 FCFA)</span>
                  </label>
                </div>

                <div className="p-4 bg-white border border-[#ece7f8] rounded-xl space-y-2.5">
                  <div className="text-xs font-bold uppercase tracking-wider text-[#15803d]">Destinataire</div>
                  <div>
                    <label className="block text-[11px] font-semibold text-gray-700 mb-0.5">Nom et prénoms</label>
                    <input
                      type="text"
                      value={rName}
                      onChange={(e) => setRName(e.target.value)}
                      className="w-full h-9 px-3 border border-indigo-200 rounded-lg text-xs"
                    />
                  </div>
                  <div>
                    <label className="block text-[11px] font-semibold text-gray-700 mb-0.5">Téléphone international</label>
                    <div className="flex gap-2">
                      <select value={rCC} onChange={(e) => setRCC(e.target.value)} className="w-24 h-9 px-2 border border-indigo-200 rounded-lg text-xs bg-white">
                        <option value="FR +33">FR +33</option>
                        <option value="BE +32">BE +32</option>
                        <option value="DE +49">DE +49</option>
                        <option value="US +1">US +1</option>
                        <option value="CA +1">CA +1</option>
                      </select>
                      <input
                        type="text"
                        value={rPhone}
                        onChange={(e) => setRPhone(e.target.value)}
                        className="flex-1 h-9 px-3 border border-indigo-200 rounded-lg text-xs"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-[11px] font-semibold text-gray-700 mb-0.5">Ville / Région</label>
                    <input
                      type="text"
                      value={rCity}
                      onChange={(e) => setRCity(e.target.value)}
                      className="w-full h-9 px-3 border border-indigo-200 rounded-lg text-xs"
                    />
                  </div>
                </div>
              </div>

              {/* Delivery Choice (Domicile vs Relais) */}
              <div className="p-4 bg-white border border-[#ece7f8] rounded-xl space-y-3">
                <div className="text-sm font-bold text-[#241f36]">Où devons-nous livrer le colis ?</div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div
                    onClick={() => setDeliveryType("relais")}
                    className={classNames(
                      "p-3.5 border-2 rounded-xl cursor-pointer transition-all flex items-start gap-3",
                      deliveryType === "relais" ? "border-blue-600 bg-blue-50/40" : "border-gray-200 bg-white"
                    )}
                  >
                    <span className={classNames("w-4 h-4 mt-0.5 rounded-full border-2 flex items-center justify-center", deliveryType === "relais" ? "border-blue-600 bg-blue-600" : "border-gray-300")} />
                    <div>
                      <div className="text-xs font-bold text-gray-900">Dans un point relais</div>
                      <div className="text-[11px] text-gray-500 mt-0.5">Retrait par le destinataire · inclus</div>
                    </div>
                  </div>

                  <div
                    onClick={() => setDeliveryType("domicile")}
                    className={classNames(
                      "p-3.5 border-2 rounded-xl cursor-pointer transition-all flex items-start gap-3",
                      deliveryType === "domicile" ? "border-blue-600 bg-blue-50/40" : "border-gray-200 bg-white"
                    )}
                  >
                    <span className={classNames("w-4 h-4 mt-0.5 rounded-full border-2 flex items-center justify-center", deliveryType === "domicile" ? "border-blue-600 bg-blue-600" : "border-gray-300")} />
                    <div>
                      <div className="text-xs font-bold text-gray-900">À domicile</div>
                      <div className="text-[11px] text-gray-500 mt-0.5">Livraison à l&apos;adresse du destinataire · +5 000 FCFA</div>
                    </div>
                  </div>
                </div>

                {deliveryType === "domicile" ? (
                  <div>
                    <label className="block text-[11px] font-semibold text-gray-700 mb-0.5">Adresse complète de livraison</label>
                    <input
                      type="text"
                      value={rAddr}
                      onChange={(e) => setRAddr(e.target.value)}
                      placeholder="Rue, numéro, code postal..."
                      className="w-full h-9 px-3 border border-indigo-200 rounded-lg text-xs"
                    />
                  </div>
                ) : (
                  <div className="space-y-2 pt-2">
                    <div className="text-xs font-bold text-gray-800">Choisissez le point relais le plus proche :</div>
                    <div className="grid gap-2">
                      {RELAIS_OPTIONS.map((po, idx) => (
                        <div
                          key={po.name}
                          onClick={() => setSelectedRelaisIdx(idx)}
                          className={classNames(
                            "p-3 rounded-xl border flex items-center justify-between gap-3 cursor-pointer",
                            selectedRelaisIdx === idx ? "border-blue-600 bg-blue-50/50" : "border-gray-200 bg-white"
                          )}
                        >
                          <div className="flex items-center gap-3">
                            <span className="w-8 h-8 rounded-lg bg-purple-100 text-purple-700 font-bold text-xs flex items-center justify-center">PR</span>
                            <div>
                              <div className="flex items-center gap-2">
                                <span className="font-bold text-xs text-gray-900">{po.name}</span>
                                <span className="text-[10px] font-bold px-2 py-0.5 rounded-full" style={{ backgroundColor: po.badgeBg, color: po.badgeFg }}>{po.badge}</span>
                              </div>
                              <div className="text-[11px] text-gray-500 mt-0.5">{po.addr}</div>
                            </div>
                          </div>
                          <span className={classNames("w-5 h-5 rounded-full border-2 flex items-center justify-center text-xs text-white", selectedRelaisIdx === idx ? "border-blue-600 bg-blue-600" : "border-gray-300")}>
                            {selectedRelaisIdx === idx ? "(Sélectionné)" : ""}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Colis characteristics */}
              <div className="p-4 bg-white border border-[#ece7f8] rounded-xl space-y-3">
                <div className="text-xs font-bold uppercase tracking-wider text-[#5b21b6]">Colis</div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                  <div>
                    <label className="block text-[11px] font-semibold text-gray-700 mb-0.5">Nombre de colis</label>
                    <input
                      type="number"
                      value={nbColis}
                      onChange={(e) => setNbColis(e.target.value)}
                      className="w-full h-9 px-3 border border-indigo-200 rounded-lg text-xs"
                    />
                  </div>
                  <div>
                    <label className="block text-[11px] font-semibold text-gray-700 mb-0.5">Poids total (kg)</label>
                    <input
                      type="number"
                      step="0.5"
                      value={poids}
                      onChange={(e) => setPoids(e.target.value)}
                      className="w-full h-9 px-3 border border-indigo-200 rounded-lg text-xs"
                    />
                  </div>
                  <div>
                    <label className="block text-[11px] font-semibold text-gray-700 mb-0.5">Dimensions L×l×H (cm)</label>
                    <input
                      type="text"
                      value={dims}
                      onChange={(e) => setDims(e.target.value)}
                      className="w-full h-9 px-3 border border-indigo-200 rounded-lg text-xs"
                    />
                  </div>
                  <div>
                    <label className="block text-[11px] font-semibold text-gray-700 mb-0.5">Nature</label>
                    <select
                      value={nature}
                      onChange={(e) => setNature(e.target.value)}
                      className="w-full h-9 px-2.5 border border-indigo-200 rounded-lg text-xs bg-white"
                    >
                      <option value="Alimentaire sec">Alimentaire sec</option>
                      <option value="Vêtements">Vêtements</option>
                      <option value="Cosmétiques">Cosmétiques</option>
                      <option value="Documents">Documents</option>
                      <option value="Effets personnels">Effets personnels</option>
                      <option value="Électroménager">Électroménager</option>
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div>
                    <label className="block text-[11px] font-semibold text-gray-700 mb-0.5">Valeur déclarée (FCFA)</label>
                    <input
                      type="number"
                      value={valeur}
                      onChange={(e) => setValeur(e.target.value)}
                      className="w-full h-9 px-3 border border-indigo-200 rounded-lg text-xs"
                    />
                  </div>
                  <div>
                    <label className="block text-[11px] font-semibold text-gray-700 mb-0.5">Source du prospect</label>
                    <select value={lead} onChange={(e) => setLead(e.target.value)} className="w-full h-9 px-2.5 border border-indigo-200 rounded-lg text-xs bg-white">
                      <option value="Facebook Ads">Facebook Ads</option>
                      <option value="TikTok">TikTok</option>
                      <option value="WhatsApp">WhatsApp</option>
                      <option value="Google Ads">Google Ads</option>
                      <option value="Parrainage">Parrainage</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-[11px] font-semibold text-gray-700 mb-0.5">Description précise du contenu</label>
                  <input
                    type="text"
                    value={desc}
                    onChange={(e) => setDesc(e.target.value)}
                    className="w-full h-9 px-3 border border-indigo-200 rounded-lg text-xs"
                  />
                </div>

                <div className="flex gap-4 flex-wrap pt-2 border-t border-gray-100">
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={insurance}
                      onChange={(e) => setInsurance(e.target.checked)}
                      className="w-4 h-4 accent-purple-700"
                    />
                    <span>Assurance All Risks (0,5 % de la valeur)</span>
                  </label>
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={packing}
                      onChange={(e) => setPacking(e.target.checked)}
                      className="w-4 h-4 accent-purple-700"
                    />
                    <span>Emballage agence (+2 500 FCFA)</span>
                  </label>
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={notify}
                      onChange={(e) => setNotify(e.target.checked)}
                      className="w-4 h-4 accent-purple-700"
                    />
                    <span>Notifications SMS / WhatsApp</span>
                  </label>
                </div>
              </div>
            </div>
          )}

          {/* STEP 3: FINANCIAL RECAP AND PAYMENT OPTIONS */}
          {step === 3 && (
            <div className="space-y-4">
              {/* Financial Box */}
              <div className="p-5 bg-[#1e3a8a] text-white rounded-xl space-y-3">
                <div className="text-lg font-bold">Confirmation et paiement</div>
                <div className="text-[11px] uppercase tracking-wider font-bold text-blue-200">Détail des frais</div>
                <div className="divide-y divide-blue-800 text-xs">
                  <div className="py-2 flex justify-between">
                    <span>Fret ({numPoids} kg × {money(currentCamp?.tarif ?? 0)} / kg)</span>
                    <span className="font-bold">{money(transport)}</span>
                  </div>
                  <div className="py-2 flex justify-between">
                    <span>Frais de gestion dossier</span>
                    <span className="font-bold">{money(gestion)}</span>
                  </div>
                  {liv > 0 && (
                    <div className="py-2 flex justify-between">
                      <span>Frais de ramassage / livraison</span>
                      <span className="font-bold">{money(liv)}</span>
                    </div>
                  )}
                  {assur > 0 && (
                    <div className="py-2 flex justify-between text-amber-200">
                      <span>Frais d&apos;assurance All Risks</span>
                      <span className="font-bold">{money(assur)}</span>
                    </div>
                  )}
                  <div className="py-2 flex justify-between">
                    <span>Entreposage (agence Cameroun)</span>
                    <span className="font-bold">{money(entrepot)}</span>
                  </div>
                  <div className="py-2 flex justify-between">
                    <span>Dédouanement</span>
                    <span className="font-bold">{money(douane)}</span>
                  </div>
                  {emb > 0 && (
                    <div className="py-2 flex justify-between">
                      <span>Emballage agence</span>
                      <span className="font-bold">{money(emb)}</span>
                    </div>
                  )}
                </div>

                <div className="pt-3 border-t border-blue-700 flex justify-between items-baseline">
                  <div>
                    <div className="text-sm font-bold">Montant total à régler :</div>
                    <div className="text-[11px] text-blue-200">Réf. devis TRQ/2026/0142</div>
                  </div>
                  <div className="text-2xl font-black text-amber-300">
                    {money(total)}
                  </div>
                </div>
              </div>

              {/* Payment Method Selector */}
              <div className="p-4 bg-white border border-[#ece7f8] rounded-xl space-y-2.5">
                <div className="text-sm font-bold text-gray-900">Mode de paiement</div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5">
                  <div
                    onClick={() => setPayMode("direct")}
                    className={classNames(
                      "p-3 rounded-xl border cursor-pointer transition-all",
                      payMode === "direct" ? "border-blue-600 bg-blue-50/50" : "border-gray-200 bg-white"
                    )}
                  >
                    <div className="font-bold text-xs text-gray-900">Paiement Mobile Money direct</div>
                    <div className="text-[11px] text-gray-500 mt-1">Lien de paiement envoyé par SMS et WhatsApp</div>
                  </div>
                  <div
                    onClick={() => setPayMode("ref")}
                    className={classNames(
                      "p-3 rounded-xl border cursor-pointer transition-all",
                      payMode === "ref" ? "border-blue-600 bg-blue-50/50" : "border-gray-200 bg-white"
                    )}
                  >
                    <div className="font-bold text-xs text-gray-900">Paiement déjà reçu</div>
                    <div className="text-[11px] text-gray-500 mt-1">Saisie de la transaction OM ou InTouch</div>
                  </div>
                  <div
                    onClick={() => setPayMode("later")}
                    className={classNames(
                      "p-3 rounded-xl border cursor-pointer transition-all",
                      payMode === "later" ? "border-blue-600 bg-blue-50/50" : "border-gray-200 bg-white"
                    )}
                  >
                    <div className="font-bold text-xs text-gray-900">Enregistrer en devis</div>
                    <div className="text-[11px] text-gray-500 mt-1">Paiement ultérieur avant clôture du départ</div>
                  </div>
                </div>

                {payMode === "ref" && (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 pt-2">
                    <input
                      type="text"
                      value={refOM}
                      onChange={(e) => setRefOM(e.target.value)}
                      placeholder="Réf. Orange Money (MP...)"
                      className="h-9 px-3 border border-orange-200 rounded-lg text-xs"
                    />
                    <input
                      type="text"
                      value={refTouch}
                      onChange={(e) => setRefTouch(e.target.value)}
                      placeholder="Réf. In Touch (ITX-...)"
                      className="h-9 px-3 border border-cyan-200 rounded-lg text-xs"
                    />
                  </div>
                )}
              </div>
            </div>
          )}

          {/* STEP 4: SUCCESS */}
          {step === 4 && (
            <div className="text-center py-6 space-y-4 max-w-md mx-auto">
              <div className="w-14 h-14 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mx-auto">
                <CheckCircleIcon className="w-9 h-9" />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900">Enregistrement pris en compte</h3>
                <div className="text-[11px] text-gray-500 uppercase font-bold tracking-wider mt-2">Numéro d&apos;expédition</div>
                <div className="font-mono text-2xl font-bold text-blue-700 mt-0.5">{generatedCode}</div>
              </div>

              <div className="flex gap-2 justify-center pt-2">
                <button
                  type="button"
                  onClick={() => onFlash(`Reçu PDF téléchargé — ${generatedCode}`)}
                  className="flex items-center gap-1.5 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-bold text-xs"
                >
                  <DocumentArrowDownIcon className="w-4 h-4" />
                  Télécharger Reçu / Devis
                </button>
                <button
                  type="button"
                  onClick={() => onFlash(`Lien envoyé par WhatsApp à ${sName}`)}
                  className="flex items-center gap-1.5 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg font-bold text-xs"
                >
                  <ShareIcon className="w-4 h-4" />
                  Partager WhatsApp
                </button>
              </div>

              <div className="p-3 bg-emerald-50 border border-emerald-200 rounded-xl text-emerald-800 text-xs text-left mt-4">
                <strong>Notification transmise</strong>
                <p className="mt-0.5 text-[11px] text-emerald-700">L&apos;expéditeur et le destinataire ont reçu les instructions de dépôt et le lien de suivi en direct.</p>
              </div>
            </div>
          )}
        </div>

        {/* Modal Bottom Bar (Matches Screenshot) */}
        <div className="p-4 bg-white border-t border-gray-100 flex items-center justify-between gap-3 shrink-0">
          <div>
            <div className="text-[11px] text-gray-500">Campagne</div>
            <div className="text-base font-bold text-[#1f1b2e]">
              {currentCamp ? currentCamp.name : "Aucune sélection"}
            </div>
          </div>

          <div className="flex items-center gap-2.5">
            <button
              type="button"
              onClick={handleBack}
              className="h-10 px-4 border border-gray-300 bg-white hover:bg-gray-50 text-gray-700 font-bold rounded-lg text-xs cursor-pointer"
            >
              {step === 1 ? "Annuler" : step === 4 ? "Fermer" : "Précédent"}
            </button>
            <button
              type="button"
              onClick={handleNext}
              disabled={submitting || (step === 1 && !selectedCampId)}
              className={classNames(
                "h-10 px-5 text-white font-bold rounded-lg text-xs cursor-pointer shadow-xs transition-colors",
                submitting || (step === 1 && !selectedCampId)
                  ? "bg-purple-300 cursor-not-allowed"
                  : "bg-[#6d28d9] hover:bg-purple-800"
              )}
            >
              {submitting
                ? "Traitement en cours..."
                : step === 1
                ? "Continuer"
                : step === 2
                ? "Voir le récapitulatif"
                : step === 3
                ? "Confirmer et payer"
                : "Terminer"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// -------------------------------------------------------------
// STEPPER MODAL: LIVRAISON URBAINE
// -------------------------------------------------------------
interface UrbainStepperModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (code: string) => void;
  onFlash: (msg: string) => void;
}

export function UrbainStepperModal({
  isOpen,
  onClose,
  onSuccess,
  onFlash,
}: UrbainStepperModalProps) {
  const [city, setCity] = useState("Douala");
  const [fromZone, setFromZone] = useState("Akwa");
  const [toZone, setToZone] = useState("Bonapriso");
  const [sName, setSName] = useState("");
  const [sPhone, setSPhone] = useState("");
  const [rName, setRName] = useState("");
  const [rPhone, setRPhone] = useState("");
  const [slot, setSlot] = useState("Dès que possible");
  const [weight, setWeight] = useState("2");
  const [cashOnDelivery, setCashOnDelivery] = useState("0");

  if (!isOpen) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const payload: CreateExpeditionDTO = {
        contactExpediteur: sName,
        telExpediteur: sPhone,
        adresseExpediteur: `${city}, ${fromZone}`,
        contactDestinataire: rName,
        telDestinataire: rPhone,
        adresseDestination: `${city}, ${toZone}`,
        villeExpedition: city === "Douala" ? 1 : 2,
        villeDestination: city === "Douala" ? 1 : 2,
        montant: 2500,
        montantARecupererAuClientFinal: Number(cashOnDelivery) || 0,
        payeur: "EXPEDITEUR",
        modePaiement: "ESPECE",
        colis: [
          {
            description: "Livraison urbaine",
            poidsColis: Number(weight) || 1,
            nombre: 1,
          },
        ],
      };
      const res = await createExpedition(payload);
      const code = res.numLt || `LIV-${res.id}`;
      onSuccess(code);
      onFlash(`Livraison urbaine ${code} créée avec succès · Clementino`);
      onClose();
    } catch (err: any) {
      onFlash("Erreur lors de la création de la livraison: " + (err?.message || "Erreur serveur"));
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/55 backdrop-blur-xs animate-fade-in font-['Public_Sans',sans-serif]">
      <div className="bg-white rounded-2xl border border-gray-200 shadow-2xl max-w-lg w-full p-5 space-y-4 text-[#1f1b2e]">
        <div className="flex items-center justify-between border-b border-gray-100 pb-3">
          <div className="flex items-center gap-2">
            <span className="w-2.5 h-2.5 rounded-full bg-blue-600" />
            <h3 className="font-bold text-base text-gray-900">Nouvelle livraison urbaine</h3>
          </div>
          <button type="button" onClick={onClose} className="p-1 rounded text-gray-400 hover:text-gray-600">
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-3 text-xs">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block font-semibold text-gray-700 mb-1">Ville</label>
              <select value={city} onChange={(e) => setCity(e.target.value)} className="w-full h-8 px-2 border border-gray-300 rounded bg-white">
                <option value="Douala">Douala</option>
                <option value="Yaoundé">Yaoundé</option>
              </select>
            </div>
            <div>
              <label className="block font-semibold text-gray-700 mb-1">Créneau horaire</label>
              <select value={slot} onChange={(e) => setSlot(e.target.value)} className="w-full h-8 px-2 border border-gray-300 rounded bg-white">
                <option value="Dès que possible">Dès que possible</option>
                <option value="09:00–12:00">09:00–12:00</option>
                <option value="12:00–15:00">12:00–15:00</option>
                <option value="15:00–18:00">15:00–18:00</option>
              </select>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block font-semibold text-gray-700 mb-1">Quartier ramassage</label>
              <input type="text" required value={fromZone} onChange={(e) => setFromZone(e.target.value)} className="w-full h-8 px-2.5 border border-gray-300 rounded" />
            </div>
            <div>
              <label className="block font-semibold text-gray-700 mb-1">Quartier livraison</label>
              <input type="text" required value={toZone} onChange={(e) => setToZone(e.target.value)} className="w-full h-8 px-2.5 border border-gray-300 rounded" />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block font-semibold text-gray-700 mb-1">Expéditeur (Nom & Tél)</label>
              <input type="text" required placeholder="Nom" value={sName} onChange={(e) => setSName(e.target.value)} className="w-full h-8 px-2.5 border border-gray-300 rounded mb-1.5" />
              <input type="text" required placeholder="+237 6..." value={sPhone} onChange={(e) => setSPhone(e.target.value)} className="w-full h-8 px-2.5 border border-gray-300 rounded" />
            </div>
            <div>
              <label className="block font-semibold text-gray-700 mb-1">Destinataire (Nom & Tél)</label>
              <input type="text" required placeholder="Nom" value={rName} onChange={(e) => setRName(e.target.value)} className="w-full h-8 px-2.5 border border-gray-300 rounded mb-1.5" />
              <input type="text" required placeholder="+237 6..." value={rPhone} onChange={(e) => setRPhone(e.target.value)} className="w-full h-8 px-2.5 border border-gray-300 rounded" />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block font-semibold text-gray-700 mb-1">Poids colis (kg)</label>
              <input type="number" step="0.5" value={weight} onChange={(e) => setWeight(e.target.value)} className="w-full h-8 px-2.5 border border-gray-300 rounded" />
            </div>
            <div>
              <label className="block font-semibold text-gray-700 mb-1">Contre-remboursement (FCFA)</label>
              <input type="number" value={cashOnDelivery} onChange={(e) => setCashOnDelivery(e.target.value)} className="w-full h-8 px-2.5 border border-gray-300 rounded" />
            </div>
          </div>

          <div className="flex gap-2 pt-3 border-t border-gray-100">
            <button type="button" onClick={onClose} className="flex-1 h-9 border border-gray-300 rounded-lg text-gray-700 font-semibold cursor-pointer">
              Annuler
            </button>
            <button type="submit" className="flex-1 h-9 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg cursor-pointer">
              Affecter le coursier
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// -------------------------------------------------------------
// STEPPER MODAL: PROSPECT / DEVIS RAPIDE
// -------------------------------------------------------------
interface ProspectModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (name: string) => void;
  onFlash: (msg: string) => void;
}

export function ProspectModal({
  isOpen,
  onClose,
  onSuccess,
  onFlash,
}: ProspectModalProps) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [corridor, setCorridor] = useState("Cameroun → France");
  const [source, setSource] = useState("WhatsApp");
  const [volKg, setVolKg] = useState("20");
  const [timeline, setTimeline] = useState("Cette semaine");

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSuccess(name);
    onFlash(`Prospect ${name} enregistré · devis envoyé sur WhatsApp`);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/55 backdrop-blur-xs animate-fade-in font-['Public_Sans',sans-serif]">
      <div className="bg-white rounded-2xl border border-gray-200 shadow-2xl max-w-md w-full p-5 space-y-4 text-[#1f1b2e]">
        <div className="flex items-center justify-between border-b border-gray-100 pb-3">
          <div className="flex items-center gap-2">
            <span className="w-2.5 h-2.5 rounded-full bg-purple-700" />
            <h3 className="font-bold text-base text-gray-900">Nouveau prospect / Devis rapide</h3>
          </div>
          <button type="button" onClick={onClose} className="p-1 rounded text-gray-400 hover:text-gray-600">
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-3 text-xs">
          <div>
            <label className="block font-semibold text-gray-700 mb-1">Nom du client ou entreprise</label>
            <input type="text" required value={name} onChange={(e) => setName(e.target.value)} placeholder="Ex: Boutique Marie Grace" className="w-full h-8 px-2.5 border border-gray-300 rounded" />
          </div>
          <div>
            <label className="block font-semibold text-gray-700 mb-1">Téléphone / WhatsApp</label>
            <input type="text" required value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+237 6..." className="w-full h-8 px-2.5 border border-gray-300 rounded" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block font-semibold text-gray-700 mb-1">Corridor souhaité</label>
              <select value={corridor} onChange={(e) => setCorridor(e.target.value)} className="w-full h-8 px-2 border border-gray-300 rounded bg-white">
                {CORRIDORS_LIST.slice(1).map((c) => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block font-semibold text-gray-700 mb-1">Source prospect</label>
              <select value={source} onChange={(e) => setSource(e.target.value)} className="w-full h-8 px-2 border border-gray-300 rounded bg-white">
                <option value="WhatsApp">WhatsApp</option>
                <option value="Facebook Ads">Facebook Ads</option>
                <option value="TikTok">TikTok</option>
                <option value="Google Ads">Google Ads</option>
                <option value="Parrainage">Parrainage</option>
              </select>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block font-semibold text-gray-700 mb-1">Volume estimé (kg)</label>
              <input type="number" value={volKg} onChange={(e) => setVolKg(e.target.value)} className="w-full h-8 px-2.5 border border-gray-300 rounded" />
            </div>
            <div>
              <label className="block font-semibold text-gray-700 mb-1">Délai souhaité</label>
              <select value={timeline} onChange={(e) => setTimeline(e.target.value)} className="w-full h-8 px-2 border border-gray-300 rounded bg-white">
                <option value="Cette semaine">Cette semaine</option>
                <option value="Semaine prochaine">Semaine prochaine</option>
                <option value="Dans le mois">Dans le mois</option>
                <option value="Flexible">Flexible</option>
              </select>
            </div>
          </div>

          <div className="flex gap-2 pt-3 border-t border-gray-100">
            <button type="button" onClick={onClose} className="flex-1 h-9 border border-gray-300 rounded-lg text-gray-700 font-semibold cursor-pointer">
              Annuler
            </button>
            <button type="submit" className="flex-1 h-9 bg-purple-700 hover:bg-purple-800 text-white font-bold rounded-lg cursor-pointer">
              Enregistrer le prospect
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// -------------------------------------------------------------
// TRACKING MODAL: SUIVI COLIS DIRECT EN MODALE (SANS REDIRECTION)
// -------------------------------------------------------------
interface SuiviColisModalProps {
  isOpen: boolean;
  onClose: () => void;
  onFlash: (msg: string) => void;
}

export function SuiviColisModal({
  isOpen,
  onClose,
  onFlash,
}: SuiviColisModalProps) {
  const [trackQuery, setTrackQuery] = useState("");
  const [found, setFound] = useState(false);
  const [expeditionData, setExpeditionData] = useState<ClementinoExpedition | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!isOpen) return null;

  const handleTrace = async () => {
    if (!trackQuery.trim()) return;
    setLoading(true);
    setError(null);
    try {
      const res = await getExpeditionShow(trackQuery.trim());
      if (res && (res.id || res.numLt)) {
        setExpeditionData(res);
        setFound(true);
        onFlash("Suivi actualisé depuis Clementino");
      } else {
        setError("Aucune expédition trouvée pour ce numéro.");
        setFound(false);
      }
    } catch (err: any) {
      setError("Expédition non trouvée sur Clementino ou clé d API Gateway requise.");
      setFound(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/55 backdrop-blur-xs animate-fade-in font-['Public_Sans',sans-serif]">
      <div className="bg-white rounded-2xl border border-gray-200 shadow-2xl max-w-xl w-full p-5 space-y-4 text-[#1f1b2e]">
        <div className="flex items-center justify-between border-b border-gray-100 pb-3">
          <div className="flex items-center gap-2">
            <MagnifyingGlassIcon className="w-5 h-5 text-purple-700" />
            <h3 className="font-bold text-base text-gray-900">Suivi et Traçabilité Colis</h3>
          </div>
          <button type="button" onClick={onClose} className="p-1 rounded text-gray-400 hover:text-gray-600">
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>

        <div className="flex gap-2">
          <input
            type="text"
            value={trackQuery}
            onChange={(e) => setTrackQuery(e.target.value)}
            placeholder="N° d'expédition ou AWB / BL..."
            className="flex-1 h-9 px-3 border border-purple-200 rounded-lg text-xs"
          />
          <button
            type="button"
            disabled={loading}
            onClick={handleTrace}
            className="h-9 px-4 bg-purple-700 hover:bg-purple-800 disabled:opacity-50 text-white font-bold text-xs rounded-lg cursor-pointer flex items-center gap-1.5"
          >
            {loading && <ArrowPathIcon className="w-3.5 h-3.5 animate-spin" />}
            <span>Tracer</span>
          </button>
        </div>

        {error && (
          <div className="p-3 bg-rose-50 border border-rose-200 text-rose-800 rounded-lg text-xs">
            {error}
          </div>
        )}

        {found && expeditionData && (
          <div className="p-4 bg-purple-50/50 border border-purple-100 rounded-xl space-y-3 text-xs">
            <div className="flex items-center justify-between">
              <div>
                <span className="font-mono font-bold text-purple-900 text-sm">{expeditionData.numLt || `EXP-${expeditionData.id}`}</span>
                <div className="text-[11px] text-gray-500">
                  {typeof expeditionData.villeExpedition === "object" ? expeditionData.villeExpedition?.nom : String(expeditionData.villeExpedition || "Origine")} → {typeof expeditionData.villeDestination === "object" ? expeditionData.villeDestination?.nom : String(expeditionData.villeDestination || "Destination")}
                </div>
              </div>
              <span className="px-2.5 py-1 bg-amber-100 text-amber-900 font-bold rounded-full text-[11px]">
                {normalizeStatus(expeditionData.status) || "Statut inconnu"}
              </span>
            </div>

            {/* Stepper timeline */}
            <div className="space-y-2 pt-2 border-t border-purple-100">
              <div className="flex items-center gap-3">
                <span className="w-3 h-3 rounded-full bg-emerald-600" />
                <div className="flex-1 flex justify-between">
                  <span className="font-semibold text-gray-900">Dossier créé en agence</span>
                  <span className="text-[11px] text-gray-500">26/09 09:12</span>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className="w-3 h-3 rounded-full bg-amber-500 animate-pulse" />
                <div className="flex-1 flex justify-between">
                  <span className="font-semibold text-gray-900">En attente de pesée & dépôt</span>
                  <span className="text-[11px] text-gray-500">Agence Akwa</span>
                </div>
              </div>
              <div className="flex items-center gap-3 opacity-40">
                <span className="w-3 h-3 rounded-full bg-gray-300" />
                <div className="flex-1 flex justify-between">
                  <span>Embarquement vol fret</span>
                  <span className="text-[11px]">Vol AF 947 (30/09)</span>
                </div>
              </div>
              <div className="flex items-center gap-3 opacity-40">
                <span className="w-3 h-3 rounded-full bg-gray-300" />
                <div className="flex-1 flex justify-between">
                  <span>Arrivée Paris CDG & Dédouanement</span>
                  <span className="text-[11px]">ETA 03/10</span>
                </div>
              </div>
            </div>

            <div className="pt-2 flex justify-end gap-2">
              <button
                type="button"
                onClick={() => onFlash("Bordereau PDF envoyé au client")}
                className="h-8 px-3 border border-purple-200 bg-white hover:bg-purple-100 text-purple-900 font-semibold rounded-lg text-xs"
              >
                Envoyer le lien WhatsApp
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// -------------------------------------------------------------
// EXPEDITION DETAILS MODAL (WHEN CLICKING ON SHIPMENT ROW)
// -------------------------------------------------------------
interface ShipmentDetailModalProps {
  shipment: any | null;
  onClose: () => void;
  onConfirmPay: (id: string, code: string) => void;
  onFlash: (msg: string) => void;
}

export function ShipmentDetailModal({
  shipment,
  onClose,
  onConfirmPay,
  onFlash,
}: ShipmentDetailModalProps) {
  if (!shipment) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-xs animate-fade-in font-['Public_Sans',sans-serif]">
      <div className="bg-white rounded-2xl border border-gray-200 shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto p-6 space-y-4 text-[#1f1b2e]">
        {/* Header */}
        <div className="flex items-start justify-between border-b border-gray-100 pb-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="px-2.5 py-1 bg-emerald-100 text-emerald-800 font-mono font-bold text-xs rounded-md">
                {shipment.code}
              </span>
              <span className="px-2.5 py-1 bg-blue-100 text-blue-800 font-mono text-xs rounded-md">
                {shipment.awb || "AWB en attente"}
              </span>
              <span className="px-2.5 py-1 bg-purple-100 text-purple-900 font-bold text-xs rounded-md">
                {shipment.mode}
              </span>
            </div>
            <h2 className="text-lg font-bold text-gray-900 mt-2">
              {shipment.from} → {shipment.to}
            </h2>
            <p className="text-xs text-gray-500">{shipment.corridor} · {shipment.departInfo}</p>
          </div>
          <button type="button" onClick={onClose} className="p-1 rounded text-gray-400 hover:text-gray-600">
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>

        {/* Core Info Grid */}
        <div className="grid grid-cols-2 gap-4 text-xs">
          <div className="p-3.5 bg-gray-50 rounded-xl space-y-1">
            <span className="font-bold text-orange-800 uppercase text-[10px]">Expéditeur</span>
            <div className="font-bold text-sm text-gray-900">{shipment.sender}</div>
            <div className="text-gray-600 font-mono">{shipment.phone}</div>
          </div>
          <div className="p-3.5 bg-gray-50 rounded-xl space-y-1">
            <span className="font-bold text-emerald-800 uppercase text-[10px]">Destinataire</span>
            <div className="font-bold text-sm text-gray-900">{shipment.receiver}</div>
            <div className="text-gray-600 font-mono">{shipment.receiverPhone}</div>
          </div>
        </div>

        {/* Cargo & Payment Info */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 p-3.5 bg-purple-50/40 border border-purple-100 rounded-xl text-xs">
          <div>
            <span className="text-[10px] uppercase font-bold text-gray-400">Poids & Colis</span>
            <div className="font-bold text-gray-900">{shipment.poids} kg ({shipment.colis} colis)</div>
            <div className="text-[11px] text-gray-500">{shipment.nature}</div>
          </div>
          <div>
            <span className="text-[10px] uppercase font-bold text-gray-400">Montant total</span>
            <div className="font-bold text-purple-950 text-sm">{money(shipment.montant)}</div>
            <div className="text-[11px] text-gray-500">Paiement: {shipment.pay}</div>
          </div>
          <div>
            <span className="text-[10px] uppercase font-bold text-gray-400">Départ & ETA</span>
            <div className="font-bold text-gray-900">{shipment.depart}</div>
            <div className="text-[11px] text-gray-500">ETA {shipment.eta}</div>
          </div>
          <div>
            <span className="text-[10px] uppercase font-bold text-gray-400">Statut logistique</span>
            <div className="font-bold text-emerald-700">{shipment.logi}</div>
            <div className="text-[11px] text-gray-500">{shipment.logiInfo}</div>
          </div>
        </div>

        {/* Actions bar inside modal */}
        <div className="p-3 bg-gray-50 rounded-xl space-y-2">
          <div className="text-xs font-bold text-gray-900">Actions sur cette expédition</div>
          <div className="flex gap-2 flex-wrap">
            {!shipment.confirmed && (
              <button
                type="button"
                onClick={() => {
                  onConfirmPay(shipment.id, shipment.code);
                  onClose();
                }}
                className="h-8 px-3.5 bg-emerald-600 hover:bg-emerald-700 text-white font-bold rounded-lg text-xs cursor-pointer shadow-xs"
              >
                Confirmer le paiement
              </button>
            )}
            <button
              type="button"
              onClick={() => onFlash(`Bordereau / étiquette générée pour ${shipment.code}`)}
              className="h-8 px-3 border border-purple-200 bg-white hover:bg-purple-50 text-purple-900 font-semibold rounded-lg text-xs cursor-pointer"
            >
              Imprimer étiquette
            </button>
            <button
              type="button"
              onClick={() => onFlash(`WhatsApp envoyé à ${shipment.sender}`)}
              className="h-8 px-3 border border-gray-300 bg-white hover:bg-gray-50 text-gray-700 font-semibold rounded-lg text-xs cursor-pointer"
            >
              WhatsApp Client
            </button>
            <button
              type="button"
              onClick={() => onFlash(`Notification transporteur envoyée pour ${shipment.code}`)}
              className="h-8 px-3 border border-gray-300 bg-white hover:bg-gray-50 text-gray-700 font-semibold rounded-lg text-xs cursor-pointer"
            >
              Suivi transporteur
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
